export default "__VITE_ASSET__D7uqIquk__ 640w, __VITE_ASSET__cc9bzUAd__ 1024w, __VITE_ASSET__2LQ7Pz6g__ 1536w";